import { IColor, IColorModel } from "@montana/models/generated/cms.interface";

export interface IColorExtended extends IColor {
    hexCode?: string;
}

const colorModelToColor = (model: IColorModel): IColorExtended => ({
    colorId: model.colorId,
    colorName: model.displayValue,
    colorSwatchImage: model.colourSwatchImage ? { url: model.colourSwatchImage } : undefined,
    surfaceLook: model.surface,
    hexCode: model.hexCode,
    link: model.materialLink ? { url: model.materialLink } : undefined,
});

export const getColorSwatchesById = (colorIds: string[] | undefined, colors: IColorModel[]): IColorExtended[] => {
    if (!colorIds) {
        return [];
    }
    return colorIds.reduce<IColorExtended[]>((acc, id) => {
        const match = colors.find(c => c.colorId === id);
        if (match) {
            acc.push(colorModelToColor(match));
        }
        return acc;
    }, []);
};
